export default "__VITE_ASSET__DhSEfJt2__"